module.exports = {
    siteCensus: {
        responsysTrackingPixel: 'https://emailonline.woolworths.com.au/pub/cct?_ri_=X0Gzc2X%3DYQpglLjHJlTQGtC0r9zd59j6TCftglzbGONNW&_ei_=El69Zfbs5ddWnWyOwa--6Do&ORDERID={OrderID}&ORDERTOTAL={OrderTotal}&NUMITEMS={OrderQty}&CUSTOMERID={ShopperID}',
    },
};



// WEBPACK FOOTER //
// ./src/common/settings/groups/site-census.js